import "../../style.css";
import "../Advance/IncentivesAdvances.css";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { RxCross2 } from "react-icons/rx";
import { MdClear } from 'react-icons/md';

import { AgGridReact } from "ag-grid-react";
import { ToastContainer, toast } from "react-toastify";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

import CustomPagination from "../../../../components/CustomPagination";
import TableSkeleton from "../../../../components/table/TableSkeleton.js";

import {
  getIncentivePayrollEmployeePath,
  calculateEarnedSalaryPath,
  addIncentiveTypeStaffPath,
  addIncentiveStaffPath,
} from "../../../../services/config";
import {
  commonSaveData,
  initCommonState,
} from "../../../../redux/slices/commonSlice.js";

import {
  saveUpdateIncentive,
  initIncentiveState,
} from "../../../../redux/slices/incentiveSlice.js";

import {
  fetchBranchData,
  initBranchState,
} from "../../../../redux/slices/branchSlice";
import {
  fetchDepartmentData,
  initDepartState,
} from "../../../../redux/slices/departmentSlice";
import {
  fetchData,
  initShiftState,
} from "../../../../redux/slices/shiftsSlice";

import { useDispatch, useSelector } from "react-redux";
import { Height } from "@mui/icons-material";
import Widgets from "../../../../components/Widgets/index.js";

import {
  getInitials,
  getInitialColor,
  getCapitalizeWord,
  formatIndianAmountType
} from "../../../../services/commonServices.js";

import { HasPermission } from "../../../../services/hasPermission.js";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Incentive = () => {
  const dispatch = useDispatch();

  const user = JSON.parse(localStorage.getItem("user_data")) || {};

  const branchState = useSelector((state) => state.branch);
  const departState = useSelector((state) => state.department);
  const shiftState = useSelector((state) => state.shift);
  const commonStore = useSelector((state) => state.common);
  const incentiveStore = useSelector((state) => state.incentive);

  const getData = useCallback(() => {
    dispatch(fetchBranchData(user.user_id));
    dispatch(fetchDepartmentData(user.user_id));
    dispatch(fetchData(user.user_id));
  }, []);

  const [incentiveList, setIncentiveList] = useState([]);
  const [incentiveListOne, setIncentiveListOne] = useState([]);
  const [incentiveTypeList, setIncentiveTypeList] = useState([]);
  const [branch, setBranch] = useState([]);
  const [depart, setDepart] = useState([]);
  const [shift, setShift] = useState([]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const [startLeavingDate, setStartLeavingDate] = useState(null);
  const [endLeavingDate, setEndLeavingDate] = useState(null);
  const [addPreIncentive, setAddPreIncentive] = useState({});
  const [isActive, setIsActive] = useState(false);

  const [state, setState] = useState({
    payrollMonth: "",
    branch: "",
    shiftId: "",
  });

  const [searchQuery, setSearchQuery] = useState("");

  const [maxMonth, setMaxMonth] = useState("");
  const [open, setOpen] = useState(false);

  const [gridApi, setGridApi] = useState(null);

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  useEffect(() => {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    setMaxMonth(`${year}-${month}`);
    setState((prev) => ({
      ...prev,
      payrollMonth: `${year}-${month}`,
    }));
  }, []);

  const handelChange = ({ target: { name, value } }) => {
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (state.payrollMonth) {
      getIncentivePayroll();
    }
  }, [state.payrollMonth, state.branch, state.shiftId]);

  const getIncentivePayroll = () => {
    if (state.payrollMonth) {
      const data = {
        path: calculateEarnedSalaryPath,
        data: {
          userId: user.user_id,
          selectedDate: `${state.payrollMonth}-01`,
          branchId: state.branch || null,
          shiftId: state.shiftId || null,
        },
      };
      dispatch(commonSaveData(data));
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [isAddType, setIsAddType] = useState(false);

  useEffect(() => {
    if (branchState.brnGetSuccess) {
      setBranch(branchState.brnGetData);
      dispatch(initBranchState());
    }

    if (departState.depGetSuccess) {
      setDepart(departState.depGetData);
      dispatch(initDepartState());
    }

    if (shiftState.shiftGetSuccess) {
      setShift(shiftState.shiftGetData);
      dispatch(initShiftState());
    }
    if (commonStore.commonSuccess) {
      if (searchQuery != "") {
        searchEmployees(searchQuery, commonStore.commonData?.staffDetails)
      } else {
        setIncentiveList(commonStore.commonData?.staffDetails);
        setIncentiveListOne(commonStore.commonData?.staffDetails);
        dispatch(initCommonState());
        getData();
      }

    }
    if (incentiveStore.incSuccess) {
      getIncentivePayroll();
      toast.success(incentiveStore.incMessage);
      dispatch(initIncentiveState());
      setIncentiveStaff((prev) => ({
        ...prev,
        staffId: addPreIncentive.staffId,
        type: "",
        amount: "",
        incentiveDate: "",
        notes: "",
      }));
      if (isAddType) {
        handleClose();
        setIsAddType(false);
      }

      if (isAddType == false) {
        toggleInActive();
      }
    }
  }, [branchState, departState, shiftState, commonStore, incentiveStore]);

  const addIncentive = (data) => {
    setAddPreIncentive(data);
    setIsActive(true);
  };

  const handleClickFromD1 = (id) => {
    document.getElementById(id).click();
  };

  const date = new Date();
  const year = date.getFullYear();
  const month = date.toLocaleString("default", { month: "long" });

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  // Calculate total CTC
  const totalCTC = useMemo(() => {
    if (!Array.isArray(incentiveList) || incentiveList.length === 0) {
      return 0;
    }
    
    return incentiveList.reduce((total, item) => {
      const ctcValue = item.CostToCompany || item.ctc || 0;
      return total + (parseFloat(ctcValue) || 0);
    }, 0);
  }, [incentiveList]);

  // Calculate total incentive
  const totalIncentive = useMemo(() => {
    if (!Array.isArray(incentiveList) || incentiveList.length === 0) {
      return 0;
    }
    
    return incentiveList.reduce((total, item) => {
      const incentiveValue = parseFloat(
        item.salaryCountDays?.incentiveAmount || 
        item.totalIncentive || 
        0
      ) || 0;
      return total + incentiveValue;
    }, 0);
  }, [incentiveList]);

  const columns = useMemo(
    () => [
      {
        headerName: "SNo",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 60,
        pinned: "left",
      },
      {
        headerName: "Employee ID",
        field: "employeeId",
        pinned: "left",
        width: 120,
      },
      {
        headerName: "Name",
        field: "staffName",
        filter: true,
        pinned: "left",
        height: "60px",
        width: "350px",
        cellRenderer: (row) => {
          return (
            <span
              className="table-link d-flex align-items-center justify-content-start gap-2"
            >
              <div
                style={{
                  width: "30px",
                  height: "30px",
                  border: "1px solid lightgray",
                  borderRadius: "50%",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: getInitialColor(row.data.staffName),
                  color: "white",
                  fontWeight: "bold",
                  fontSize: "12px",
                }}
              >
                {getInitials(row.data.staffName)}
              </div>
              {getCapitalizeWord(row.data.staffName)}
            </span>
          );
        },
      },
      {
        headerName: "Job title",
        field: "jobTitle",
        filter: true,
      },

      {
        headerName: "CTC",
        field: "ctc",
        filter: true,
        cellRenderer: (row) => {
          return (
            <span>
              {" "}
              {row.data.CostToCompany ? formatIndianAmountType(row.data.CostToCompany) : "-"}{" "}
            </span>
          );
        },
      },
      {
        headerName: "Total Incentive",
        field: "totalIncentive",
        flex: 1,
        filter: true,
        cellRenderer: (row) => {
          return (
            <span>
              {row.data.salaryCountDays?.incentiveAmount
                ? formatIndianAmountType(row.data.salaryCountDays.incentiveAmount)
                : "-"}{" "}
            </span>
          );
        },
      },

      {
        headerName: "Actions",
        cellRenderer: (row) => {
          return HasPermission("Incentive", "create") ? (
            <div>
              <span
                style={{ color: "#8234db", cursor: "pointer" }}
                onClick={() => addIncentive(row.data)}
              >
                Add Incentive
              </span>
            </div>
          ) : (
            "-"
          );
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
        width: "200px",
      },
    ],
    []
  );

  const toggleInActive = () => {
    setIsActive(false);
    setAddPreIncentive({});
  };

  const [incentiveType, setIncentiveType] = useState({
    userId: user.user_id,
    staffId: "",
    type: "",
  });

  const [incentiveStaff, setIncentiveStaff] = useState({
    userId: user.user_id,
    staffId: addPreIncentive.staffId,
    type: "",
    amount: "",
    incentiveDate: "",
    notes: "",
  });

  const handleTypeChange = ({ target: { name, value } }) => {
    if (value == "AddIncentiveType") {
      handleClickOpen();
      setIncentiveType((prev) => ({
        ...prev,
        staffId: addPreIncentive.staffId,
      }));
      setIsAddType(true);
    } else {
      setIncentiveStaff((prev) => ({
        ...prev,
        [name]: value,
        staffId: addPreIncentive.staffId,
      }));
    }
  };

  const handleType = ({ target: { name, value } }) => {
    setIncentiveType((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddIncentive = () => {
    const incentiveTypeListArr = [...incentiveTypeList];
    let type = { type: incentiveType.type };
    incentiveTypeListArr.push(type);
    setIncentiveTypeList(incentiveTypeListArr);
    const data = {
      path: addIncentiveTypeStaffPath,
      data: incentiveType,
    };
    dispatch(saveUpdateIncentive(data));
  };

  const handelSaveIncentiveStaff = () => {
    const data = {
      path: addIncentiveStaffPath,
      data: incentiveStaff,
    };
    dispatch(saveUpdateIncentive(data));
  };

  const filterRecord = ({ target: { checked } }) => {
    if (checked) {
      const array = incentiveListOne.filter((item) => item.status == "Active");
      setIncentiveList(array);
    } else {
      setIncentiveList(incentiveListOne);
    }
  };

  const searchEmployees = (value, dataList) => {
    setSearchQuery(value);
    const filteredEmployees = dataList.filter((v) =>
      v.staffName.toLowerCase().includes(value.toLowerCase()) ||
      (v.employeeId && v.employeeId.toLowerCase().includes(value.toLowerCase()))
    );
    setIncentiveList(filteredEmployees);
    setIncentiveListOne(dataList)
  };

  const resetFilter = () => {
    setIncentiveList(incentiveListOne);
    setSearchQuery("");
    document.querySelector("#filterCheckbox").checked = false;
  };

  const date_1 = new Date();
  const year_1 = date_1.getFullYear();
  const month_1 = String(date_1.getMonth() + 1).padStart(2, "0");
  const clearFilter = () => {
    const data = {
      path: calculateEarnedSalaryPath,
      data: {
        userId: user.user_id,
        selectedDate: `${year_1}-${month_1}-01`,
        branchId: "",
        shiftId: "",
      },
    };
    dispatch(commonSaveData(data));

    setSearchQuery("")
    setState((pre) => ({
      ...pre,
      payrollMonth: `${year_1}-${month_1}`,
      branch: "",
      shiftId: "",
      departmentId: "",
    }))
  };

  // HTML ELEMENT RENDERING ---------------------------------------------------
  return (
    <div>
      <div
        style={{
          position: "fixed",
          width: "calc(100% - 20px)",
          height: "100%",
          zIndex: "1",
          marginTop: "10px",
        }}
      >
        <Widgets
          body={
            <Row>
              <Col sm="12">
                <div className="filter-controls" style={{ padding: "10px 12px 4px", marginBottom: 0, display: "flex", flexWrap: "nowrap", alignItems: "center", gap: 8 }}>

                  {/* Month */}
                  <div className="field-wrap" style={{ flex: "0 0 150px" }}>
                    <span className="fi-left">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                    </span>
                    <input
                      type="month"
                      name="payrollMonth"
                      value={state.payrollMonth}
                      onChange={handelChange}
                      max={maxMonth}
                      className="filter-select"
                      onClick={(e) => e.target.showPicker?.()}
                      style={{ paddingLeft: "26px", paddingRight: "10px", cursor: "pointer" }}
                    />
                  </div>

                  {/* Branch */}
                  <div className="field-wrap" style={{ flex: "0 0 130px" }}>
                    <Form.Select
                      name="branch"
                      value={state.branch}
                      onChange={handelChange}
                      className="filter-select"
                      style={{ padding: "6px 22px 6px 10px", fontSize: 11 }}
                    >
                      <option value="">All Branches</option>
                      {branch.map((row, idx) => (
                        <option value={row.branchId} key={idx}>{row.branch_name}</option>
                      ))}
                    </Form.Select>
                    <span className="fi-right">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
                    </span>
                  </div>

                  {/* Shift */}
                  <div className="field-wrap" style={{ flex: "0 0 130px" }}>
                    <Form.Select
                      name="shiftId"
                      value={state.shiftId}
                      onChange={handelChange}
                      className="filter-select"
                      style={{ padding: "6px 22px 6px 10px", fontSize: 11 }}
                    >
                      <option value="">All Shifts</option>
                      {shift.map((row, idx) => (
                        <option value={row.shiftId} key={idx}>{row.shiftName}</option>
                      ))}
                    </Form.Select>
                    <span className="fi-right">
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="6 9 12 15 18 9"/></svg>
                    </span>
                  </div>

                  {/* Search */}
                  <div className="field-wrap search-input-wrapper" style={{ flex: "1 1 160px" }}>
                    <span className="fi-left">
                      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
                    </span>
                    <input
                      name="searchQuery"
                      value={searchQuery}
                      onChange={(e) => searchEmployees(e.target.value, incentiveListOne)}
                      placeholder="Search employee..."
                      className="filter-select"
                      style={{ paddingLeft: "26px", paddingRight: "10px", cursor: "text" }}
                    />
                  </div>

                  {/* Clear */}
                  {(searchQuery || state.payrollMonth !== `${year_1}-${month_1}` || state.shiftId || state.departmentId || state.branch) && (
                    <button type="button" className="btn-ghost" onClick={clearFilter} style={{ padding: "5px 10px", fontSize: 11, whiteSpace: "nowrap" }}>
                      <MdClear /> Clear
                    </button>
                  )}

                </div>

                <div
                  className="ag-theme-quartz custom-grid"
                  style={{
                    height: "calc(100vh - 290px)",
                    width: "100%",
                    padding: "10px 20px",
                    paddingRight: "40px",
                  }}
                >
                  {commonStore.commonLoading ? (
                    <TableSkeleton />
                  ) : (
                    <AgGridReact
                      rowData={Array.isArray(incentiveList) ? incentiveList : []}
                      columnDefs={columns}
                      pagination={true}
                      paginationPageSize={paginationPageSize}
                      onGridReady={onGridReady}
                    />
                  )}
                </div>

                <div className="d-flex align-items-center justify-content-between custom-pagination px-4">
                  {gridApi && <CustomPagination gridApi={gridApi} />}
                  <div className="d-flex align-items-center justify-content-start gap-3 color-white">
                    <div className="d-flex flex-column align-items-start">
                      <div>Total CTC: &#8377; {formatIndianAmountType(totalCTC)}</div>
                      {/* <div>Total Incentive: &#8377; {formatIndianAmountType(totalIncentive)}</div> */}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          }
        />

        <Dialog
          open={isActive}
          keepMounted
          onClose={toggleInActive}
          maxWidth="xs"
          fullWidth
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="dark-bg-color"
        >
          <DialogTitle className="dialog-title">
            <div className="dialog-title-icon">
              <span className="close-icon" onClick={toggleInActive}>
                X
              </span>
              <span className="title">Add Incentive</span>
            </div>
            <button
              className="universal-btn"
              onClick={handelSaveIncentiveStaff}
            >
              Add
            </button>
          </DialogTitle>
          <DialogContent className="pure-dark-bg-color">
            <Form className="mt-3 px-2">
              <Form.Group className=" mt-2">
                <span style={{ marginRight: "22px" }}>Type</span>
                <Form.Select
                  name="type"
                  value={incentiveStaff.type}
                  onChange={handleTypeChange}
                  className="universal-input mt-2"
                >
                  <option value="">Select incentive Type</option>
                  {incentiveTypeList?.map((row, idx) => (
                    <option value={row.type} key={idx}>
                      {row.type}
                    </option>
                  ))}
                  <option value="AddIncentiveType">+ Add Incentive Type</option>
                </Form.Select>
              </Form.Group>

              <Form.Group className=" mt-2">
                <span>Amount</span>
                <Form.Control
                  placeholder="0"
                  name="amount"
                  value={incentiveStaff.amount}
                  onChange={handleTypeChange}
                  className="universal-input mt-2"
                />
              </Form.Group>

              <Form.Group className=" mt-2">
                <span style={{ marginRight: "22px" }}>Date</span>
                <Form.Control
                  type="date"
                  max={new Date().toISOString().split("T")[0]}
                  name="incentiveDate"
                  value={incentiveStaff.incentiveDate}
                  onChange={handleTypeChange}
                  placeholder="select date"
                  className="universal-input mt-2"
                />
              </Form.Group>

              <Form.Group className=" mt-2">
                <span style={{ marginRight: "18px" }}>Notes</span>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="notes"
                  name="notes"
                  value={incentiveStaff.notes}
                  onChange={handleTypeChange}
                  style={{ height: "80px" }}
                  className="universal-input mt-2"
                />
              </Form.Group>
            </Form>
          </DialogContent>
        </Dialog>

        <Dialog
          open={open}
          TransitionComponent={Transition}
          maxWidth="xs"
          keepMounted
          onClose={handleClose}
          fullWidth
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          className="dark-bg-color"
        >
          <DialogTitle className="dialog-title">
            <div className="dialog-title-icon">
              <span className="close-icon" onClick={handleClose}>
                X
              </span>
              <span className="title">Add Incentive Type</span>
            </div>
            <button className="universal-btn" onClick={handleAddIncentive}>
              Add
            </button>
          </DialogTitle>
          <DialogContent className="pure-dark-bg-color">
            <DialogContentText id="alert-dialog-slide-description">
              <Form.Group>
                <Form.Label
                  className="mt-2 color-white"
                  style={{ fontWeight: "bold" }}
                >
                  Incentive Type
                </Form.Label>
                <Form.Control
                  name="type"
                  value={incentiveType.type}
                  placeholder="Enter incentive type"
                  onChange={handleType}
                  className="universal-input-one"
                />
              </Form.Group>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        className="toast-custom"
      />
    </div>
  );
};

export default Incentive;